import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { MaterialsModule } from '@library/common/materials';

import { ShipmentModule } from '@library/modules/shipment';
import { StatusLegendModule } from '@library/modules/status-legend';

import { TemplateWrapperComponent } from './template-wrapper.component';
import { TemplateManageComponent } from './template-manage';
import { TemplateModifyComponent } from './template-modify';

import { TemplateRouterModule } from './templates.router.module';

@NgModule({
   declarations: [
      TemplateWrapperComponent,
      TemplateManageComponent,
      TemplateModifyComponent,
   ],
   imports: [
      CommonModule,
      FormsModule,
      RouterModule,
      TemplateRouterModule,
      ShipmentModule,
      StatusLegendModule,

      MaterialsModule,
   ]
})
export class TemplatesModule { }
